var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb-area bg-img",style:({
    'background-image':
      'url(' + _vm.$backendPublic + _vm.getSettings.baner.value + ')',
  })},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"page-banner text-center"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('b-breadcrumb',{staticClass:"page-breadcrumb",attrs:{"items":_vm.items}})],1)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }